import { render, staticRenderFns } from "./subTitle.vue?vue&type=template&id=c9aafcfc&scoped=true&"
import script from "./subTitle.vue?vue&type=script&lang=js&"
export * from "./subTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9aafcfc",
  null
  
)

export default component.exports